module.exports = __webpack_public_path__ + "static/media/new-banner-video-md.070f907d.mp4";